import { FC, useMemo } from "react";
import { CalendarSidebarTitle, CalendarSidebarWrapper, CalendatSidebarSelectWrapper } from "./styles"
import { AddLarge } from "shared/ui/icons";

import Button from '@atomaro/ui-kit/components/Button/Button/Button';
import PickerDate from '@atomaro/ui-kit/components/PickerDate/PickerDate';
import Multiselect from '@atomaro/ui-kit/components/Multiselect/Multiselect';
import { useHivesStore } from "entities/hives";
import { toRem } from "shared/helpers";

type CalendarSidebarProps = {
  activeDate: Date;
  onPlusClick: () => void;
  onChangeFilters: (filters: {date?: Date,hiveIds?: string[]}) => void
}
export const CalendarSidebar: FC<CalendarSidebarProps> = ({
  activeDate,
  onPlusClick,
  onChangeFilters
}) => {
  const hives = useHivesStore(s => s.hives);
  const hiveItems = useMemo(() => {
    return hives.map(hive => ({value: `№${hive.number}`, key: hive.id}))
  }, [hives])

  return (
    <CalendarSidebarWrapper>
      <CalendarSidebarTitle>
        Календарь
      </CalendarSidebarTitle>
      <Button 
        onClick={onPlusClick}
        label="Новое событие"
        iconPrefix={<AddLarge />}
      />
      <PickerDate 
        activeDate={activeDate}
        onSelect={(activeDate: Date) => onChangeFilters({date: activeDate})}
      />
      <CalendatSidebarSelectWrapper>
        <Multiselect 
          items={hiveItems}
          size="m"
          label="Номер улья"
          placeholder="Все"
          onChange={(values) => onChangeFilters({hiveIds: values.map(el=>`${el.key}`)})}
          dropdownMenuStyle={{
            maxHeight: toRem(300),
            overflowY: 'auto'
          }}
        />
      </CalendatSidebarSelectWrapper>
    </CalendarSidebarWrapper>
  )
}